import { render, staticRenderFns } from "./test-global-controls.vue?vue&type=template&id=fa03c6c2&scoped=true&"
import script from "./test-global-controls.vue?vue&type=script&lang=js&"
export * from "./test-global-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa03c6c2",
  null
  
)

export default component.exports